module.exports = __webpack_public_path__ + "img/brazil_flag.175fe821.png";